/**
 * SDK Configuration class
 */
export abstract class SDKConfig {
    public static dateFormat = 'yyyy-MM-dd HH:mm';
    public static dateFormatFull = 'yyyy-MM-dd HH:mm:ss';
    public static dateFormatFullMs = 'yyyy-MM-dd HH:mm:ss.SSS';
    public static datePickerDateFormat = 'yy-mm-dd';
    public static datePickerHourFormat = 'HH:mm';
}
